import { withInstall } from '../helpers';

import Col from './src/QCol.vue';

export const QCol = withInstall(Col);

export type { QColProps, QColInstance } from './src/types';
